/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sidebar_Privacy_PolicyInputs */

const en_admin_sidebar_privacy_policy = /** @type {(inputs: Admin_Sidebar_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy policy`)
};

const de_admin_sidebar_privacy_policy = /** @type {(inputs: Admin_Sidebar_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutz`)
};

/**
* | output |
* | --- |
* | "Privacy policy" |
*
* @param {Admin_Sidebar_Privacy_PolicyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_sidebar_privacy_policy = /** @type {((inputs?: Admin_Sidebar_Privacy_PolicyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sidebar_Privacy_PolicyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_sidebar_privacy_policy(inputs)
	return en_admin_sidebar_privacy_policy(inputs)
});